import React, { Component } from "react";
import {SubsidiaryUtils} from "../../../utils/Subsidiary/SubsidiaryUtils";
import { vppsStoreSelectors } from "../store/store";
import { connect } from "react-redux";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
interface SubsidiaryFilterProps {
    subsidiaryList: any[];
    filter: string[];
    onFilterSubsidiary: (subsidiaries) => void;
}

class SubsidiaryFilter extends Component<SubsidiaryFilterProps, {}> {
    selectMenu: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.selectMenu = React.createRef();
    }

    clearFilter = () => {
        this.selectMenu.current.selectItem([]);
        this.selectMenu.current.setDisplayString("Choose Subsidiary...");
    };

    render() {
        const preSelectedValue = this.props.filter ? this.props.filter[0] : "";
        return (
            <Components.SelectMenu
                ref={this.selectMenu}
                noValueLabel="Choose Subsidiary..."
                multipleSelection
                items={
                    this.props.subsidiaryList &&
                    this.props.subsidiaryList.length > 0
                        ? SubsidiaryUtils.subsidiarySelectItems(this.props.subsidiaryList)
                        : []
                }
                onChange={this.props.onFilterSubsidiary}
                value={preSelectedValue}
            />
        );
    }
}

const mapStateToProps = state => ({
    subsidiaryList: vppsStoreSelectors.subsidiaryList(state)
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(
    SubsidiaryFilter
);
